import { Spinner } from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import { TransactionType } from "../../constants/types";
import FooterButtons from "./components/FooterButtons";
import { TransactionIconMapping } from "./utils";
import DefiTopOpportunity from "./components/DefiTopOpportunity";
import { Typography } from "@kelp-dao/kernel-design-system";
import useDefiData from "@hooks/useDefiData";

interface WrapUnwrapSuccessProps {
  transactionType?: TransactionType;
  isSpinnerRequired?: boolean;
  modalTitle: string;
  modalSubTitle?: string;
  primaryBtnTxt?: string;
  secondaryBtnTxt?: string;
  onSubmitPrimary?: () => void;
  onSubmitSecondary?: () => void;
  onTxView?: () => void;
  isWrap?: boolean;
}

const WrapUnwrapSuccess = ({
  isSpinnerRequired = false,
  transactionType,
  modalTitle,
  modalSubTitle,
  primaryBtnTxt,
  secondaryBtnTxt,
  onTxView,
  onSubmitPrimary,
  onSubmitSecondary,
  isWrap,
}: WrapUnwrapSuccessProps) => {
  const defiData = useDefiData({
    type: "restake",
  });
  return (
    <div
      className={`flex flex-col items-center text-center w-full rounded-3xl mt-8 md:mt-12 ${
        !isWrap ? "px-8 md:px-36 pb-10" : "px-0"
      }`}
    >
      {isSpinnerRequired && (
        <div className="flex items-center justify-center h-40 w-40">
          <Spinner
            size="xl"
            thickness="4px"
            speed="0.75s"
            color="textPrimary"
          />
        </div>
      )}
      {transactionType && (
        <BaseImage
          src={TransactionIconMapping[transactionType].icon}
          width={48}
          height={48}
          alt="icon"
        />
      )}
      <Typography
        type="heading"
        variant="medium"
        className={`text-text-primary font-sans font-semibold ${
          isSpinnerRequired ? "mt-4" : "mt-8"
        } text-xl md:text-2xl leading-7`}
      >
        {modalTitle}
      </Typography>

      <div className="flex items-center justify-center gap-1 mt-2 text-center">
        <Typography
          type="body"
          variant="xsmall"
          className="text-text-secondary"
        >
          {modalSubTitle}
        </Typography>
      </div>

      <div className="flex items-center justify-center gap-1 mt-2 text-center">
        <button
          onClick={onTxView}
          className="text-text-secondary border-b border-dashed border-text-secondary cursor-pointer hover:opacity-80 transition-opacity"
        >
          <Typography
            type="body"
            variant="xsmall"
            className="text-text-secondary"
          >
            View Transaction
          </Typography>
        </button>
      </div>

      {isWrap && (
        <div
          className={`bg-[#f4f4f7] w-full pb-6 flex flex-col mt-6 px-6 rounded-b-[1.5rem] ${
            defiData ? "gap-6" : ""
          }`}
        >
          <Typography
            type="body"
            variant="small"
            className="text-text-secondary md:px-24 mt-6"
          >
            Maximise your rewards with exclusive DeFi opportunities!
          </Typography>
          <DefiTopOpportunity type="restake" />

          {primaryBtnTxt || secondaryBtnTxt ? (
            <FooterButtons
              secondaryBtnTxt={secondaryBtnTxt}
              onSubmitSecondary={onSubmitSecondary}
              primaryBtnTxt={primaryBtnTxt}
              onSubmitPrimary={onSubmitPrimary}
            />
          ) : null}
        </div>
      )}
    </div>
  );
};

export default WrapUnwrapSuccess;
